import React, { useState } from "react";
import PropTypes from "prop-types";
import Plot from "react-plotly.js";
import { Button, Modal } from "antd";
import "./index.scss";

export const ELFPlot = ({ test, ref_spd, wavelengths }) => {
  const [showInfo, setInfoModal] = useState(false);

  const InfoModal = (
    <Modal
      title="Spectral Power Distributions"
      visible={showInfo}
      onCancel={() => setInfoModal(false)}
      footer={[
        <Button key="close" onClick={() => setInfoModal(false)}>
          Close
        </Button>,
      ]}
    >
      The test source and reference illuminant SPDs are scaled so that the
      luminance factor (Y) of each is 100.
    </Modal>
  );

  return (
    <>
      <Plot
        className="elf-plot"
        useResizeHandler={true}
        // style={{ width: "100%", marginTop: "1.7rem" }}
        data={[
          {
            name: "Test",
            x: wavelengths,
            y: test,
            type: "scatter",
            mode: "lines+points",
            hovertemplate: "%{y:.4f}",
            marker: { color: "red" },
          },
          {
            name: "Reference",
            x: wavelengths,
            y: ref_spd,
            type: "scatter",
            mode: "lines+points",
            hovertemplate: "%{y:.4f}",
            marker: { color: "black" },
          },
        ]}
        layout={{
          width: 500,
          height: 250,
          legend: {
            x: 0.7,
            // y: 0.6,
          },
          margin: {
            l: 48,
            r: 12,
            b: 45,
            t: 2,
            pad: 0,
          },
          xaxis: {
            range: [380, 780],
            autotick: false,
            title: {
              text: "Wavelength (nm)",
              font: {
                size: 16,
              },
            },
            tick0: 380,
            dtick: 50,
            ticklen: 6,
            tickwidth: 2,
            mirror: "ticks",
            linewidth: 2,
            linecolor: "black",
            fixedrange: true,
          },
          yaxis: {
            title: {
              text: "Radiant Power <br /> (Equal Luminous Flux)",
              font: {
                size: 16,
              },
            },
            range: [0, Math.round(Math.max(...test)) + 1],
            showticklabels: false,
            mirror: "ticks",
            linewidth: 2,
            linecolor: "black",
            fixedrange: true,
          },
        }}
        config={{
          displaylogo: false,
          modeBarButtons: [
            [
              "toImage",
              {
                name: "Info",
                icon: "",
                click: () => setInfoModal(true),
              },
            ],
          ],
          responsive: true,
          toImageButtonOptions: {
            format: "png", // one of png, svg, jpeg, webp
            filename: "Equal Luminous Flux",
            height: 250,
            width: 500,
            scale: 1.5, // Multiply title/legend/axis/canvas sizes by this factor
          },
        }}
      />
      {InfoModal}
    </>
  );
};

ELFPlot.propTypes = {
  test: PropTypes.array,
  ref_spd: PropTypes.array,
  wavelengths: PropTypes.array,
};
